import Typography from '@mui/material/Typography'
// import Container from '@mui/material/Container'
import ImageWithSkeleton from '../../components/ImageWithSkeleton.js'
import Box from '@mui/material/Box'
import { fadeInAnimation } from '../../utils/cssFunctions.js'

export default function OtherPagesHeader ({ image, title, subtitle, ratio, titleFontSize, subtitleFontSize }) {
  return (
    <>
      <Box
        sx={{
          overflow: 'hidden',
          width: '100%',
          position: 'relative',
          ...fadeInAnimation,
          '&::after': {
            content: '""',
            position: 'absolute',
            inset: 0,
            boxShadow: (theme) => `inset 0 0 0 1px ${theme.palette.divider}`
          },
          '&::before': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '160px',
            background: 'linear-gradient(to top, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%)',
            zIndex: 3
          }
        }}
      >
        <ImageWithSkeleton src={image} ratio={ratio} square />
      </Box>
      {/* </Grid> */}
      {/* The following grid has to move up, around 240px to come at the bottom of the grid above. */}
      <Box
        sx={{
          px: 2,
          maxWidth: 960,
          position: 'absolute',
          bottom: 0,
          zIndex: 1,
          // pb: 4,
          ...fadeInAnimation
        }}
      >
        <Typography
          component='h1'
          sx={{
            textAlign: 'left !important',
            color: 'white !important',
            fontSize: titleFontSize ?? { xs: '1.5rem', md: '2rem' },
            fontWeight: 700,
            ...fadeInAnimation
          }}
        >
          {title}
        </Typography>

        <Typography
          component='h2'
          sx={{
            textAlign: 'left !important',
            color: 'white !important',
            fontSize: subtitleFontSize ?? { xs: '1.1rem', sm: '1.3rem' },
            ...fadeInAnimation
          }}
        >
          {subtitle}
        </Typography>
      </Box>
    </>
  )
}
